import React from 'react'
import { Link } from 'react-router-dom'
import { AiFillStar } from 'react-icons/ai';
import { FormattedMessage } from 'react-intl';
import { DateTime } from 'luxon';
import { useSelector } from 'react-redux';
import { SUPER_ADMIN_ROLE } from '../../../constants';

const Item = ({ data }) => {
    const user = useSelector(state => state.user);

    return (
        data.case ?
            <>
                <a href={user.role === SUPER_ADMIN_ROLE ? `/cases/${data.case.id}` : `/cases/${data.case.id}`} className='bg-white hover:bg-gray-50 border-b-[1px] border-gray-100 py-3 px-2 block'>
                    <div className="mb-2 flex items-center space-x-3 hover:bg-base-200 text-sm">
                        <span className="relative flex h-3 w-3">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
                        </span>
                        <p className="flex-grow font-bold">
                            <FormattedMessage id={data.message} defaultMessage="New Notifaction" />
                        </p>

                    </div>
                    <p className="mb-2 text-xs text-gray-500 font-medium">
                        <FormattedMessage id="created_at" defaultMessage="Created at: " />: {DateTime.fromISO(data.created_at).toFormat("ff")}
                    </p>
                    <div className="flex space-x-3">
                        <div className='h-5 w-5 rounded-full bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${data.case.profile_photo.file})` }}>

                        </div>
                        <p className="mb-2 text-xs text-gray-500 font-medium">
                            <FormattedMessage id="status" defaultMessage="Status: " />: <span className='uppercase font-bold'>{data.case.status}</span>
                        </p>
                    </div>

                </a>
            </>
            :
            <>
                <a href={data.ticket ? `/support/${data.ticket.id}` : data.case ? `/case/${data.case.id}` : ""} className='bg-white hover:bg-gray-50 border-b-[1px] border-gray-100 py-3 px-2 block'>
                    <div className="mb-2 flex items-center space-x-3 hover:bg-base-200 text-sm">
                        <span className="relative flex h-3 w-3">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-3 w-3 bg-sky-500"></span>
                        </span>
                        <p className="flex-grow font-bold">
                            <FormattedMessage id={data.message} defaultMessage="New Notifaction" />
                        </p>

                    </div>
                    <p className="mb-2 text-xs text-gray-500 font-medium">
                        <FormattedMessage id="created_at" defaultMessage="Created at: " />: {DateTime.fromISO(data.created_at).toFormat("ff")}
                    </p>

                    <p className="mb-2 text-xs text-gray-500 font-medium">
                        <FormattedMessage id="status" defaultMessage="Status: " />: <span className='uppercase font-bold'>{data.ticket.status}</span>
                    </p>

                </a>
            </>
    )
}

export default Item